/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Settings_DescriptionInputs */



/**
* | output |
* | --- |
* | "Uno is an in-product assistant that helps your team navigate oneAI, answer product questions, and get tasks done." |
*
* @param {Uno_Settings_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_settings_description = /** @type {((inputs?: Uno_Settings_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Settings_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Uno ist ein integrierter Assistent, der Ihrem Team hilft, oneAI zu bedienen, Produktfragen zu beantworten und Aufgaben zu erledigen.")
	return /** @type {LocalizedString} */ ("Uno is an in-product assistant that helps your team navigate oneAI, answer product questions, and get tasks done.")
});